import { createUseStyles } from 'react-jss'

export default createUseStyles({
  switchAdTypeBtn: {
    width: '100%',
    marginTop: 20,
    marginBottom: 10
  }
})
